// ====== DISCUSSION EDIT HISTORY FEATURE START ======
export async function GetDiscussionHistoryApi(discussionId) {
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    const url = `${process.env.REACT_APP_API_URL}v1/plans/discussion/${discussionId}/history`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('HTTP Error Response:', errorText);
      return { success: false, message: `HTTP ${response.status}: ${errorText}` };
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching discussion history:', error);
    return { success: false, message: error.message };
  }
}
// ====== DISCUSSION EDIT HISTORY FEATURE END ======
